import styled from 'styled-components'
import { Accordion } from '../../components/UI/Accordion'
import { StyledCheckList } from '../../components/UI/CheckListItem'
import { IconWrapper } from '../../components/UI/Icon'
import { containerDefault } from '../../lib/styles/Container'
import { typoHeading3, typoHeading5, typoParagraphS } from '../../lib/styles/Typography'

export const StyledWrapper = styled.div`
  ${containerDefault}
  margin: 3rem auto;
`

export const StyledHeadline = styled.h2`
  max-width: 32rem;
  margin-bottom: 1.5rem;
  ${typoHeading3}
`

export const StyledFeaturesAccordion = styled(Accordion)``

export const StyledFeaturesAccordionHeadline = styled.h3`
  ${typoHeading5}
  max-width: 32rem;
`

export const StyledFeaturesAccordionImages = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 1rem;
  row-gap: 0.5rem;
`

export const StyledFeaturesAccordionImagesItem = styled.img`
  max-height: 1rem;
`

export const StyledFeaturesColumns = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 3rem;
  row-gap: 4rem;

  padding-bottom: 2rem;

  @media screen and (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 2rem;
  }

  @media screen and (max-width: 540px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 2rem;
  }

  ${IconWrapper} {
    color: ${({ theme }) => theme.colors.black[1]};
  }
`

export const StyledFeaturesColumnsItem = styled.div<{
  multiColumn: boolean
}>`
  flex: 1 1 auto;

  ${StyledCheckList} {
    column-count: ${({ multiColumn }) => (multiColumn ? '2' : '1')};

    p {
      ${typoParagraphS}
    }
  }

  @media screen and (max-width: 540px) {
    ${StyledCheckList} {
      column-count: unset;
    }
  }
`

export const StyledFeaturesMulticolumnsItem = styled.div`
  padding-bottom: 2rem;
  column-count: 3;
  gap: 3rem;
  column-width: calc(100% / 3);

  li {
    break-inside: avoid;
  }

  ${IconWrapper} {
    color: var(--c-base-theme-3);
  }

  ${StyledCheckList} {
    p {
      ${typoParagraphS}
    }
  }

  @media screen and (max-width: 992px) {
    gap: 2rem;
    column-count: 2;
    column-width: calc(100% / 2);
  }

  @media screen and (max-width: 540px) {
    column-count: 1;
    column-width: 100%;
  }
`

export const StyledFeaturesColumnsHeadline = styled.h4`
  max-width: 32rem;
  margin-bottom: 0.5rem;
`
